import { formatMoney } from './formatters';
import { monthShort } from './intlFormatters';

// "Jan 2019", from the backend's "2019-01-10".
const monthAndYear = (iso) => {
  const [year, month] = iso.split('-').map(Number);
  return `${monthShort(month - 1)} ${year}`;
};

// The one line under the similar movements' title: the summary of a huge
// group, else the rhythm, else nothing. `t` reads the movements namespace.
export function similarLine(similar, t) {
  const { summary, rhythm } = similar;
  if (summary) {
    return t('detailPanel.similar.summary', {
      count: new Intl.NumberFormat('en-US').format(summary.total),
      date: monthAndYear(summary.since),
      amount: formatMoney(summary.amount, summary.currency),
      perMonth: summary.per_month,
    });
  }
  if (rhythm) {
    const cadence = t(`detailPanel.similar.rhythm.${rhythm.cadence}`, { day: rhythm.day_of_month });
    return rhythm.amount == null
      ? cadence
      : `${cadence} · ${t('detailPanel.similar.rhythm.usualAmount', { amount: formatMoney(rhythm.amount, rhythm.currency) })}`;
  }
  return null;
}
